import types from './actionTypes';

const initialState = {
  commissions: [],
  loading: false,
  error: null,
  message: null,
};

const commissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_COMMISSIONS_STATE:
      return initialState;
    case types.FETCH_COMMISSIONS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_COMMISSIONS.SUCCESS:
      return {
        ...state,
        loading: false,
        commissions: [...action.commissions],
      };
    case types.FETCH_COMMISSIONS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default commissionReducer;
